import React from 'react';

import autoBind from 'react-autobind';
import { If, Then } from 'react-if'
import Switch, { Case } from 'react-switch-case';
import { withRouter } from "react-router-dom";

// import other components within the same project here
import Config from "composer/Config.jsx";
import Localization from "composer/Localization.jsx"
import API from "composer/tools/API.jsx"
import UserDataProfile from 'composer/dataProviders/UserDataProfile.jsx';
import LoginPage from "composer/pages/LoginPage.jsx";
import LocaleViewerPage from "composer/pages/LocaleViewerPage.jsx";
import LoginCreateSession from "composer/tools/LoginCreateSession.jsx";
import TopBar from "composer/views/TopBar.jsx";
import HotspotViewerPage from "composer/pages/HotspotViewerPage.jsx";
import Loading from "composer/views/Loading.jsx";
import ConfirmDialog from "composer/views/ConfirmDialog.jsx";
import Notification from "composer/views/Notification.jsx"
import RetrieverPage from "composer/pages/RetrieverPage.jsx"

import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { indigo, pink } from '@material-ui/core/colors';

const STATUS_REQUIRE_LOGIN = -1;
const STATUS_VIEW_LOCALE = 0;
const STATUS_VIEW_HOTSPOT = 1;
const STATUS_VIEW_RETRIEVER = 2;


const styles = {
  loadingOverlay: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    zIndex: '99998',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    filter: 'blur(10px)',
  },
  none: {
  },
}

const theme = createMuiTheme({
  palette: {
    primary: {
      main: indigo[500],
    },
    secondary: {
      main: pink["A400"],
    },
  },
  typography: {
    fontFamily: [
      "Roboto",
      "Noto Sans TC",
    ].join(','),
  },
});

const keys = [];
let previousKey;

class RootPage extends React.Component {

  STATUS_REQUIRE_LOGIN() {
    return STATUS_REQUIRE_LOGIN;
  }

  STATUS_VIEW_LOCALE() {
    return STATUS_VIEW_LOCALE;
  }

  STATUS_VIEW_HOTSPOT() {
    return STATUS_VIEW_HOTSPOT;
  }

  STATUS_VIEW_RETRIEVER() {
    return STATUS_VIEW_RETRIEVER;
  }

  constructor(props) {
    super(props);
    this.refs = React.createRef();

    window.onbeforeunload = function(){return false;}

    // state variables here
    this.state = {
      status: STATUS_REQUIRE_LOGIN,
      currentLocale: null,
      isLoading: false,
    };

    autoBind(this);
    // this is the default language, hard code now, later change it to obey user preference
    Localization.strings.setLanguage("tc");


    // TODO: have some language BUGs, eric will resolve them
    this.state.status_titles = [
      Localization.strings.LOCALE_LIST,
      Localization.strings.HOTSPOT_EDIT,
      Localization.strings.RETRIEVER
    ];

  }

  componentWillMount(){
    this.props.history.listen(this.historyOnChange);
  }

  componentDidMount(){
    const userdata = localStorage.getItem('userdata');
    if(userdata){
      const foundUser = JSON.parse(userdata);
      this.setLogin(foundUser);
    }
  }

  historyOnChange(location) {
    console.log('historyOnChange');
    const { key } = location;
    let goBack = false;
    // If there is no key, it was a goBack.
    if (key === undefined) {
      goBack = true;
      //return;
    }
    // If it's an entirely new key, it was a goForward.
    // If it was neither of the above, you can compare the index
    // of `key` to the previous key in your keys array.
    if (!keys.includes(key)) {
      keys.push(key);
    } else if (keys.indexOf(key) < keys.indexOf(previousKey)) {
      goBack = true;
    }
    previousKey = key;

    let path = this.props.history.location.pathname;

    if (this.props.history.action === "POP") {
      if (this.state.status == STATUS_VIEW_RETRIEVER) {
        if (goBack) {
          this.refs.retrieverPage.handleBackButtonClicked();
        }
        else {
          this.refs.retrieverPage.handleForwardButtonClicked();
        }
      }
      else if (this.state.status == STATUS_VIEW_HOTSPOT) {
        if (goBack) {
          this.refs.hotspotViewerPage.handleBackButtonClicked();
        }
        else {
          this.refs.hotspotViewerPage.handleForwardButtonClicked();
        }
      }
      else if (this.state.status == STATUS_VIEW_LOCALE) {
        if (path === "/locale/hotspot") {
          this.refs.localeViewerPage.editLocale(this.props.history.location.state.locale, false);
        }
        else if (path === "/locale/retriever") {
          this.refs.localeViewerPage.retrieveAnswer(this.props.history.location.state.locale, false)
        }
      }
    }
    else if (this.props.history.action === "PUSH") {

    }

    if (path != "/" && this.state.status == STATUS_REQUIRE_LOGIN) {
      this.replaceHistory("/");
    }
  }

  pushHistory(path, object=null) {
    this.props.history.push(path, object);
  }

  goBackHistory() {
    this.props.history.goBack();
  }

  replaceHistory(path) {
    this.props.history.replace(path);
  }

  loginOK(res){
    // save the login info to local database
    localStorage.setItem('userdata', JSON.stringify(res));
    this.setLogin(res);
  }

  setLogin(res){
    // Sucessful login
    // 1. update user information from server and store locally
    if(this.refs.userDataProfile === undefined){return}
    this.refs.userDataProfile.updateUserInfo(res);
    // 2. update school information from server and store locally
    this.refs.userDataProfile.updateSchoolInfo(res);
    // 3. update kla and subject information from server and store locally
    this.refs.userDataProfile.getKLAAndSubjectFromServer();

    this.changeStatus(STATUS_VIEW_LOCALE);
    this.pushHistory("/locale");
  }

  changeStatus(newStatus) {
    this.setState({
      status: newStatus
    });
    this.state.status = newStatus;

    if (this.refs.localeViewerPage != null) {
      this.refs.localeViewerPage.setState({ active: (newStatus == STATUS_VIEW_LOCALE) });
    }
  }

  setCurrentLocale(locale) {
    this.setState({ currentLocale: locale });
    this.state.currentLocale = locale;
  }

  getCurrentLocale() {
    return this.state.currentLocale;
  }

  languageChanged() {
    this.forceUpdate();
  }

  showLoading() {
    this.setState({ isLoading: true });
    this.state.isLoading = true;
  }

  hideLoading() {
    this.setState({ isLoading: false });
    this.state.isLoading = false;
  }

  addNotification(message, success=true) {
    this.refs.notification.add(message, success);
  }

  render() {

    return (
      <ThemeProvider theme={theme}>
        <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Noto+Sans+TC:300,400,500,700&display=swap" />
        <div>
          <API root={this} parent={this} ref="API"/>
          <UserDataProfile root={this} parent={this} ref="userDataProfile"/>
          <Loading root={this} parent={this} isLoading={this.state.isLoading}/>
          <ConfirmDialog root={this} parent={this} ref="confirmDialog"/>
          <Notification root={this} parent={this} ref="notification"/>

          <div style={this.state.isLoading? styles.loadingOverlay : styles.none}>
            <If condition={this.state.status != STATUS_REQUIRE_LOGIN}>
              <Then>
                <TopBar root={this} parent={this} ref="topBar"/>
                <LocaleViewerPage root={this} parent={this} ref="localeViewerPage"/>
              </Then>
            </If>


            <If condition={Config.IS_UNIT_TEST() === true}>
              <Then>
                <LoginCreateSession parent={this} root={this} ref="loginCreateSession"
                  username="" password=""
                  loginOKFunction = {this.loginOK}
                  loginFailFunction = {null}/>
              </Then>
            </If>

            <Switch condition={this.state.status}>

              <Case value={STATUS_REQUIRE_LOGIN}>
                <LoginPage root={this} parent={this}/>
              </Case>

              <Case value={STATUS_VIEW_HOTSPOT}>
                <HotspotViewerPage root={this} parent={this} currentLocale={this.state.currentLocale} ref="hotspotViewerPage"/>
              </Case>

              <Case value={STATUS_VIEW_RETRIEVER}>
                <RetrieverPage root={this} parent={this} ref="retrieverPage"
                  localeData={this.state.currentLocale}
                />
              </Case>

            </Switch>
          </div>
        </div>
      </ThemeProvider>
    )
  }

  // data functions
  getMyUserId(){
    return this.refs.userDataProfile.state.userInfo.id;
  }
  getMySchoolId(){ 
    return this.refs.userDataProfile.state.userInfo.school_id;
  }

  getSameSchoolEdit() {
    return parseInt(this.refs.userDataProfile.state.userInfo.role) >= 1;
  }

  isAdminUser() {
    return (this.getMySchoolId() == 3 && this.refs.userDataProfile.state.userInfo.role == 2);
  }

  setTitle(newTitle){
    if(this.refs.topBar != undefined){
      this.refs.topBar.setState({title: newTitle});
    }
  }
}

const withRouterAndRef = Wrapped => {
  const WithRouter = withRouter(({ forwardRef, ...otherProps }) => (
    <Wrapped ref={forwardRef} {...otherProps} />
  ))
  const WithRouterAndRef = React.forwardRef((props, ref) => (
    <WithRouter {...props} forwardRef={ref} />
  ))
  const name = Wrapped.displayName || Wrapped.name
  WithRouterAndRef.displayName = `withRouterAndRef(${name})`
  return WithRouterAndRef
}

export default withRouterAndRef(RootPage);
